import { map, isEmpty, difference } from 'lodash'
import { getScenarioColumns, getStandardColumnDefs } from './utils/table'
import { tableParser, createDynamicColumn } from 'pages/Scenario/utils/table'
import { BASE_URL } from 'config'

// TODO: Evaluate if this logic can be unified (permissions and page related columns)
export const updateTableData = ({
  t,
  gridApi,
  purgerData,
  additionalColumns
}) => {
  if (!isEmpty(purgerData)) {
    const scenariosInTable = []
    const filteredIds = map(purgerData, 'id')

    gridApi.forEachNode(({ id }) => {
      scenariosInTable.push(id)
    })

    const dataAdded = difference(filteredIds, scenariosInTable)
    const dataRemoved = difference(scenariosInTable, filteredIds)

    const rowsToAdd = purgerData.filter(({ id }) => dataAdded.includes(id))

    handleTableColumns({ t, gridApi, rows: purgerData, additionalColumns })

    gridApi.applyTransaction({
      remove: dataRemoved.map((id) => ({ id }))
    })

    gridApi.applyTransaction({
      add: tableParser({
        rowData: rowsToAdd
      })
    })

    gridApi.setSortModel([
      {
        colId: 'creationDateTime',
        sort: 'desc'
      }
    ])
    gridApi.onSortChanged()
  } else {
    gridApi.applyTransaction({
      add: []
    })
    gridApi.hideOverlay()
  }
}

// This method uses the position defined in the additional column model
// WARNING: the position starts from 1
// - If the position is either not defined or higher than the columns length,
//   it will be put at the end
// - If position === 1, it will put in head
// - If the position is in the middle of the array, a shift is performed
const switchPosition = (columns, newColumn) => {
  const { position } = newColumn

  if (!position || position > columns.length) return [...columns, newColumn]
  if (position === 1) return [newColumn, ...columns]

  return [
    ...columns.slice(0, position - 1),
    newColumn,
    columns[position - 1],
    ...columns.slice(position)
  ]
}

export const getTableColumns = ({ t, rows, additionalColumns }) => {
  // const colPermissions = get(first(rows), 'scenarioPermission.fields', {})

  let scenarioColumns = [...getScenarioColumns(t)]
  // .filter
  // (col) => colPermissions[col.field] Set permissions
  // ()

  const allowedAdditionalColumns = additionalColumns
  // .filter
  // (col) => colPermissions[col.field]
  // ()

  for (const customColumn of allowedAdditionalColumns) {
    const col = createDynamicColumn({ ...customColumn, t })
    scenarioColumns = switchPosition(scenarioColumns, col)
  }

  return [...getStandardColumnDefs(t), ...scenarioColumns]
}

export const setGridColumns = (gridApi, columns) => {
  gridApi.setColumnDefs(columns)
  gridApi.sizeColumnsToFit()
}

export const handleTableColumns = ({ t, gridApi, rows, additionalColumns }) => {
  const columns = getTableColumns({ t, rows, additionalColumns })
  setGridColumns(gridApi, columns)
  gridApi.setSortModel([
    {
      colId: 'creationDateTime',
      sort: 'desc'
    }
  ])
  gridApi.onSortChanged()
}

export const processedPurgerData = ({
  purgerData,
  query,
  scenarioPurgerName,
  email
}) => {
  const { jobType, cronStart, cronEnd, enabled, mailTo, cronExp, timezone } =
    purgerData

  return {
    scenarioPurgeName: scenarioPurgerName,
    scenarioJobName: jobType,
    cronStart,
    cronEnd,
    enabled,
    timeZone: timezone,
    mails: mailTo,
    query,
    lastTrigger: null,
    lastTriggerLocal: null,
    nextTrigger: null,
    nextTriggerLocal: null,
    payload: { query },
    httpMethod: 'DELETE',
    cronExp,
    url: `${BASE_URL}/scenarios/delete-with-query`,
    payloadMapper: [],
    user: email
  }
}
